import { motion } from 'framer-motion';
import { MarkdownContent } from './markdown-content';

interface AiStreamingMessageProps {
  content: string;
}

/** Streaming AI message with blinking cursor — stays visible until WS broadcast replaces it */
export function AiStreamingMessage({ content }: AiStreamingMessageProps): React.JSX.Element {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="rounded-md border-l-[3px] border-l-ai bg-ai/[0.08] px-3 py-2 text-sm"
    >
      <div className="mb-0.5 flex items-center gap-1.5">
        <span className="font-chakra text-[10px] font-bold uppercase tracking-widest text-ai">VTAK AI</span>
      </div>
      <div className="text-foreground">
        <MarkdownContent content={content} />
        <motion.span
          className="ml-0.5 inline-block h-4 w-0.5 bg-ai align-middle"
          animate={{ opacity: [1, 0, 1] }}
          transition={{ duration: 0.8, repeat: Infinity }}
        />
      </div>
    </motion.div>
  );
}
